import React from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import logo from '../img/logo.png';
import Box from '@material-ui/core/Box';
import Avatar from '@material-ui/core/Avatar';
import ExitToApp from '@material-ui/icons/ExitToApp';
import ArrowForward from '@material-ui/icons/ArrowForward';
import { Divider, Grid, makeStyles } from '@material-ui/core';
import logoCyD from '../img/logo-cyd.png';
import logoPSI from '../img/logo-psi.png';
import logoC3 from '../img/logo-c3.png';
import logoCDZ from '../img/logo-cdz.png';
import logoTEC from '../img/logo-cyd-tec.png';

const useStyles = makeStyles(theme => ({
  customTextField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px'
    },
    '& .MuiInputBase-root': {
      height: '45px'
    },
    '& .MuiInputLabel-root': {
      top: '-5px'
    },
    '& .MuiInputLabel-shrink': {
      top: '0'
    }
  },
  avatar: {
    width: 80,
    height: 80
  },
  columna: {
    width: '75%',
    [theme.breakpoints.down('md')]: {
      width: '90%'
    }
  },
  logoCyD: {
    marginTop: 50,
    [theme.breakpoints.down('md')]: {
      marginTop: 120
    }
  },
  logosEmpresas: {
    width: '75%',
    height: 110,
    marginTop: 20,
    [theme.breakpoints.down('md')]: {
      width: '90%',
      height: 75
    }
  }
}));

export default function SignInSide(props) {
  const { handleLogout, usuarioAutenticado, handleRedirect } = props;
  const classes = useStyles();

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      style={{ height: '100vh', minHeight: 'fit-content' }}>
      <Grid item className={classes.logoCyD}>
        <img src={logo} alt="img" width={100} />
      </Grid>
      <Grid item xs style={{ width: '100%' }}>
        <Grid container direction="column" justifyContent="center" alignItems="center" style={{ marginTop: 10 }}>
          <Grid item style={{ marginTop: 35 }}>
            <Avatar alt="RA" src={usuarioAutenticado.photoURL} className={classes.avatar} />
          </Grid>
          <Grid item style={{ marginTop: 10 }}>
            <Typography component="h1" variant="h5">
              Bienvenido, {usuarioAutenticado.displayName}
            </Typography>
          </Grid>
          <Grid item>
            <Typography>{usuarioAutenticado.email}</Typography>
          </Grid>
          <Grid item className={classes.columna} style={{ marginTop: 20 }}>
            {/* <Button
              className={classes.button}
              style={{ borderRadius: 25 }}
              variant="contained"
              color="primary"
              onClick={handleRedirect}>
              <ArrowForward /> Continuar
            </Button> */}
            <Button
              variant="outlined"
              color="primary"
              size="large"
              style={{
                borderRadius: 12,
                width: '100%',
                fontFamily: "'Roboto', Arial, sans-serif",
                fontSize: '14px',
                fontWeight: '500',
                textTransform: 'none'
              }}
              onClick={handleRedirect}>
              Continuar
            </Button>
          </Grid>
          <Grid item className={classes.columna} style={{ marginTop: 20 }}>
            {/* <Button
              className={classes.button}
              variant="outlined"
              color="default"
              style={{ borderRadius: 25 }}
              onClick={handleLogout}>
              <ExitToApp /> Cerrar Sesión
            </Button> */}
            <Button
              fullWidth
              variant="contained"
              style={{ borderRadius: '12px', textTransform: 'none' }}
              color="primary"
              size="large"
              onClick={handleLogout}
              disableElevation>
              Cerrar sesión
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid item className={classes.logosEmpresas}>
        <Divider />
        <Grid container style={{ marginTop: 15 }} justifyContent="space-between" alignItems="center">
          <img src={logoCyD} alt="img" width={50} />
          <img src={logoPSI} alt="img" width={90} />
          <img src={logoC3} alt="img" width={40} />
          <img src={logoCDZ} alt="img" width={75} />
          <img src={logoTEC} alt="img" width={50} />
        </Grid>
      </Grid>
    </Grid>
    // <div className={classes.center} style={{ paddingTop: 20 }}>
    //   <div className={classes.paper}>
    //     <div>
    //       <Avatar alt="RA" src={usuarioAutenticado.photoURL} className={classes.avatar} />
    //     </div>
    //     <br />
    //     <Typography component="h1" variant="h5">
    //       Bienvenido, {usuarioAutenticado.displayName}
    //     </Typography>
    //     <br />
    //     <Typography>{usuarioAutenticado.email}</Typography>
    //     <br />
    //   </div>
    //   <Button
    //     className={classes.button}
    //     variant="outlined"
    //     color="default"
    //     style={{ borderRadius: 25 }}
    //     onClick={handleLogout}>
    //     <ExitToApp /> Cerrar Sesión
    //   </Button>
    //   <Button
    //     className={classes.button}
    //     style={{ borderRadius: 25 }}
    //     variant="contained"
    //     color="primary"
    //     onClick={handleRedirect}>
    //     <ArrowForward /> Continuar
    //   </Button>

    //   <div className={classes.paper}>
    //     <Box className={classes.paper} mt={5}>
    //       <img src={logo} alt="img" width={100} />
    //     </Box>
    //   </div>
    // </div>
  );
}
